import { Logo } from '@kanda-libs/ks-design-library';
import etikaBadge from 'assets/etika-logo.png';

const KandaEtikaBadge = () => (
  <div className="flex flex-row mb-4">
    <Logo height={32} className="mt-1.5" />
    <p className="text-20-24-em mx-2.5 mt-2">x</p>
    <img src={etikaBadge} alt="etika" className="w-16 h-8" />
  </div>
);

KandaEtikaBadge.displayName = 'KandaEtikaBadge-view';

export default KandaEtikaBadge;
